import * as React from 'react';

import type {EntitySummaryRating} from 'nutshell-graphql-types';

import {Popover} from '../popover/popover';
import {Summary} from '../summary/summary';

import styles from './summary-popover.module.css';

type Props = {
    anchor: HTMLElement | null | undefined;
    anchorElementId: string;
    title: string;
    summary: string;
    userRating?: EntitySummaryRating | null | undefined;
    onRate?: (rating: EntitySummaryRating) => Promise<any>;
    isSavingRating?: boolean;
};

export function SummaryPopover(props: Props) {
    return (
        <Popover
            anchor={props.anchor}
            anchorElementId={props.anchorElementId}
            location='right'
            bodyColor='light'
            hideNub={true}
            // @ts-expect-error
            width={500}
            noDefaultStyling={true}
            shouldFadeIn={true}
        >
            <div className={styles.container}>
                <Summary
                    title={props.title}
                    summary={props.summary}
                    userRating={props.userRating}
                    onRate={props.onRate}
                    isSavingRating={props.isSavingRating}
                />
            </div>
        </Popover>
    );
}
